export default "__VITE_ASSET__ByKhCycP__"